import type { BlockField, BlockFieldStyle } from '@/blocks/domain/types';

/** A fresh field id — also used to mint a duplicated field's own id (never reuse the source's). */
export function makeFieldId(): string {
  return `fld-${Date.now().toString(36)}-${Math.floor(Math.random() * 1e6)}`;
}

function defaultsForStyle(style: BlockFieldStyle): Partial<BlockField> {
  if (style === 'image' || style === 'logo') return { media: { size: 'small', alignment: 'left' } };
  return {};
}

/**
 * One `BlockField` construction rule, shared by `useFieldListEditorState`'s "+ Add element" (inside
 * a `FieldListEditor` list) and the Add panel's element palette (LLAMS-610 Part 8, appends directly
 * to a block's `content.fields` from the rail's Add tab rather than through a mounted
 * `FieldListEditor`). Both call sites must agree on a new field's shape, or a field added from one
 * would round-trip differently than one added from the other.
 */
export function createBlockField(style: BlockFieldStyle, sortOrder: number): BlockField {
  return {
    id: makeFieldId(),
    label: '',
    value: '',
    width: 'full',
    align: 'left',
    style,
    visible: true,
    sortOrder,
    ...defaultsForStyle(style)
  };
}
